import Vue from 'vue'
import Vuex from 'vuex'
import constant from './constant'
import dict from './dict'
import sets from './sets'
import settings from './settings'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    constant
  },
  modules: {
    dict,
    sets,
    settings
  }
})

export default store
